import {phoneFilter} from './phone.filter';

export const filters = angular.module('filters', [
  phoneFilter.name
]);



/** WEBPACK FOOTER **
 ** ./src/app/shared/filters/filters.js
 **/